import React from "react";

const AssignmentGuide = ({ props }) => {
  const { showGuide, setShowGuide } = props;
  return (
    <div className="relative group ">
      <button
        onMouseEnter={() => setShowGuide(true)}
        className="absolute -top-1 right-0 btn btn-info  btn-sm py-2 text-white hover:font-semibold px-4 "
      >
        Help
      </button>

      {showGuide && (
        <div
          className="absolute bg-gradient-to-r z-50 from-gray-800 via-gray-900 to-black text-white px-6 py-5 rounded-lg shadow-xl top-0 right-1/2 transform translate-x-1/2 mt-10 mb-4 max-w-md w-full"
          onClick={() => setShowGuide(false)}
        >
          <h4 className="text-xl font-semibold mb-3 text-gray-100">
            Assignment Submission Guidelines
          </h4>
          <p className="text-sm text-gray-300 leading-relaxed">
            <ul className="list-disc pl-6 space-y-2">
              <li>
                You must submit the assignment before the due time. After the
                deadline, submissions will be closed.
              </li>
              <li>
                Each question has a maximum mark, which may be optional for some
                questions.
              </li>
              <li>
                For each question, you are required to provide a URL or link.
              </li>
              <li>
                If submitting a Google Drive link, ensure the access is set to
                "Anyone with the link can view".
              </li>
              <li>
                Once all URLs or links are submitted, click the "Submit" button
                to finalize your assignment submission.
              </li>
              <li>
                Please submit your assignment at least 5 minutes before the
                deadline to avoid technical glitches and delays in processing.
              </li>
            </ul>
          </p>
        </div>
      )}
    </div>
  );
};

export default AssignmentGuide;
